import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SharedModule } from "app/shared-module/shared/shared.module";
import { TableViewComponent } from "./table-view/table-view.component";
// import { MatSortModule, MatCheckboxModule } from "@angular/material";

@NgModule({
  imports: [SharedModule],
  declarations: [TableViewComponent],
  entryComponents:[TableViewComponent],
  exports: [TableViewComponent],
})
export class Common {}



// WEBPACK FOOTER //
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/common/common.module.ts